var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpApiV5Request } from './http-api-request.js';
export function getUser(config) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield new HttpApiV5Request(`user`, config).setMethod('GET').fetch();
        return res.data;
    });
}
export function getBilling(config) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield new HttpApiV5Request(`user/billing`, config).setMethod('GET').fetch();
        return res.data;
    });
}
export function getBillingCounts(config) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield new HttpApiV5Request(`user/billing/counts`, config).setMethod('GET').fetch();
        return res.data;
    });
}
export function getBillingPortalUrl(returnUrl, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield new HttpApiV5Request(`user/billing/portal`, config)
            .addParam('returnUrl', returnUrl)
            .fetch();
        return res.data;
    });
}
export function getBillingCheckoutUrl(plan, successUrl, cancelUrl, cycle, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const request = new HttpApiV5Request(`user/billing/checkout`, config).addParam('plan', plan);
        if (cycle) {
            request.addParam('cycle', cycle);
        }
        if (successUrl) {
            request.addParam('successUrl', successUrl);
        }
        if (cancelUrl) {
            request.addParam('cancelUrl', cancelUrl);
        }
        const res = yield request.fetch();
        return res.data;
    });
}
//# sourceMappingURL=user-service.js.map